<template>
    <q-list class="q-mb-md">
        <q-collapsible icon="fas fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
            <div class="row gutter-sm" v-if="options">
                <div class="col-xs-12 col-sm-12" v-if="options.product_categories">
                    <q-select chips autofocus-filter v-model="product_category"  :options="options.product_categories" multiple :float-label="$t('product_categories')" clearable />
                </div>
            </div>

            <div class="row gutter-sm justify-end q-mt-sm">
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="negative" class="full-width" :label="$t('clear_filters')" icon="fas fa-eraser" @click="clearFilter()"/>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="secondary" class="full-width" :label="$t('apply_filter_plural')" icon="fas fa-filter" @click="requestFiltered()"/>
                </div>
            </div>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
export default {
    name: 'AdminPresentialProductFilters',

    props: ['options'],

    data() {
        return {
            open: false,
            product_category: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getNameFilter() {
            return `${this.$t('filter')}`
        }
    },

    methods: {
        requestFiltered() {
            this.$emit('requestFiltered', {
                product_category: this.product_category,
            })
            setTimeout(() => { this.toggle() }, 500)
        },

        clearFilter() {
            this.product_category = []
            this.$emit('clearAndRequest')
            setTimeout(() => { this.toggle() }, 500)
        },

        toggle() {
            this.open = !this.open
        },
    }
}
</script>

<style>

</style>
